import React from "react"
import SurveyBatchDetails from "./SurveyBatchDetails"

const SettingsContent = () => (
  <SurveyBatchDetails className="text-left gap-4" />
)

export default SettingsContent
